import React, { Component } from 'react';
import {
  TableContainer,
  Paper
} from '@material-ui/core';
// import 'jspdf-autotable';
import './report.less';
import PaginationControlled from './paginations';
import { orderBy } from '../../utils/helper';

export default React.memo(class TableWithPaginations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: 0,
      rowsPerPagination: 100
    };
  }

  updateRowCount = (pageNo, rowsPerPagination) => {
    this.setState({ pageNo, rowsPerPagination });
  }

  render() {
    const { tableData = [], renderTable, order, oBy, sortData } = this.props;
    // const { pageNo, rowsPerPagination } = this.state;
    const { rowsPerPagination } = this.state;
    // const data = orderBy(tableData, oBy, order);
    const data = sortData === undefined ? orderBy(tableData, oBy, order) : sortData(tableData);
    const pageNo = data?.length > (rowsPerPagination * this.state.pageNo) ? this.state.pageNo : 0;
    // console.log(data);

    return (
      <>
        <div className="pagiContainer">
          <PaginationControlled tableLength={data?.length} updateRowCount={this.updateRowCount} pageNo={pageNo} rowsPerPagination={rowsPerPagination} />
        </div>
        <TableContainer
          component={Paper}
          style={{ maxWidth: '100vw' }}
        >
          {renderTable(rowsPerPagination > 0 ? data?.slice(pageNo * rowsPerPagination, pageNo * rowsPerPagination + rowsPerPagination) : data)}
        </TableContainer>
        <div className="pagiContainer">
          {data.length > 0 ? <PaginationControlled tableLength={tableData.length} updateRowCount={this.updateRowCount} pageNo={pageNo} rowsPerPagination={rowsPerPagination} /> : 'No data available'}
        </div>
      </>
    );
  }
});
